import { TffBookingSource, BookingSource } from '@tff/types/tff';

export const NDC_TFF_BOOKING_SOURCES: TffBookingSource[] = ['TUI-NDC-AF', 'TUI-NDC-KL', 'TUI-NDC-SQ', 'TUI-NDC-EK'];

export const NDCX_TFF_BOOKING_SOURCES: TffBookingSource[] = ['TUI-NDCX'];

export const NDC_AND_NDCX_TFF_BOOKING_SOURCES: TffBookingSource[] = [
  ...NDC_TFF_BOOKING_SOURCES,
  ...NDCX_TFF_BOOKING_SOURCES,
];

export const SUPPORTED_ANCILLARIES_BOOKING_SOURCES = new Set<TffBookingSource>([
  'TUI-NSK',
  ...NDC_AND_NDCX_TFF_BOOKING_SOURCES,
]);

export const NDC_AND_NDCX_BOOKING_SOURCES: BookingSource[] = ['AF', 'KL', 'SQ', 'EK', 'NDCX'];
